import { render, staticRenderFns } from "./BindsDialogContent.vue?vue&type=template&id=48001e64&"
import script from "./BindsDialogContent.vue?vue&type=script&lang=js&"
export * from "./BindsDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./BindsDialogContent.vue?vue&type=style&index=0&id=48001e64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports